module.exports = "/images/vendor/flag-icon-css/flags/4x3/kr.svg?60fde7fc2f6005c1131b87ce63370ffd";